/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

function patchMhmCachedMarkup() {
  const linkFixes = new Map([
    ['/pages/ambassadors', '/pages/about?view=ambassadors'],
    ['/pages/about?view=contact', '/pages/contact'],
    ['mailto:support@matchhermood.com', 'mailto:matchhermood@gmail.com'],
  ]);

  document.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    if (linkFixes.has(href)) {
      link.setAttribute('href', linkFixes.get(href));
    }
  });

  document
    .querySelectorAll('input[name="contact[Content categories][]"]')
    .forEach((input) => input.setAttribute('name', 'contact[Content categories]'));

  document
    .querySelectorAll('input[name="contact[Content-format preferences][]"]')
    .forEach((input) => input.setAttribute('name', 'contact[Content-format preferences]'));

  document
    .querySelectorAll('meta[name="description"], meta[property="og:description"], meta[name="twitter:description"]')
    .forEach((meta) => {
      const content = meta.getAttribute('content');
      if (content?.includes('Apparrel')) meta.setAttribute('content', content.replaceAll('Apparrel', 'Apparel'));
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', patchMhmCachedMarkup, { once: true });
} else {
  patchMhmCachedMarkup();
}
